import { Button } from '@mui/material'

// Imports custom
import { FileManagerList } from 'common'
import { TooltipInformation } from 'common'

export const VehicleImagesTable = ({useFetchInit}) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    const {FormVehicle:{formState}} = Forms

    const {fetchVehicleImages:{vehiclesImages}} = FetchData
        
    // const {formOpeningMode } = globalStates 

    const {handleClickDeleteVehicleImage, handleClickDownloadImage} = Actions

    const cellRendererTooltip = (params) => {
        //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
        const {idimage, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
        return(
            <>
                <TooltipInformation 
                    idregistro={idimage}
                    usuario_creo={usuario_creo}
                    fecha_creo={fecha_creo}
                    usuario_modifico={usuario_modifico}
                    fecha_modifico={fecha_modifico}
                />
            </>
            
        )
    }

    const cellRendererOptions = (params) => {

        const { idimage, document_originalname, document_path} = params.data
        

          return (
            <>
                <Button
                    variant='contained' 
                    size='small' 
                    color='success' 
                    onClick={(event) => handleClickDownloadImage( document_originalname, document_path )}
                    style={ { marginRight: '0.4vh' } }> 
                    <i className="fa-solid fa-download" style={{ marginRight: '8px' }}></i> Descargar
                </Button>
                <Button 
                    variant='contained' 
                    size='small' 
                    onClick={() => handleClickDeleteVehicleImage(idimage)}  
                    color='error' 
                    style={ { marginRight: '0.4vh' } }  > 
                    <i className="fa-solid fa-trash" style={{ marginRight: '8px' }}></i> Eliminar
                </Button>
            </>
          )

        
        
    }

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info", 
            minWidth: 120,
            maxWidth: 120,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: cellRendererTooltip
        },
        { field: "document_originalname", headerName: "NOMBRE DEL ARCHIVO", minWidth: 300, filter: true },
        {
            headerName: "OPCIONES",minWidth: 400,
            cellRenderer: cellRendererOptions
        },
    ]

    
    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <div className='content'>
            <FileManagerList
                rowConfig={formState.images}
                // rowConfig={vehiclesImages}
                columnConfig={columnConfig}
            />
        </div>
    )
    
}